import { PredefinedPayloadExtractor } from '../../../redux/list/list-payload-extractor';
import {
  appendNewItem,
  removeItem,
  updateItemByKey,
} from '../../../redux/list/list-update.reducer';
import {
  createDefaultListState,
  createListReducer,
  ListState,
} from '../../../redux/list/list.reducer';
import { Reducer } from '../../../redux/redux.types';
import { PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES } from '../../project-overview/project-overview-members/project-overview-members.actions';
import { TEAM_MEMBERS_LIST_ACTION_NAMES } from '../team-members-list/team-members-list.actions';
import { TEAM_MEMBERS_ACTION_NAMES } from '../team.actions';
import { TeamMember } from '../team.types';
import { normalizeInvitation, normalizeSecurityGroups } from '../team.utils';

export type TeamInvitationsListState = ListState<TeamMember>;

export const teamInvitationsListDefaultState: TeamInvitationsListState =
  createDefaultListState<TeamMember>();

const membersReducer: Reducer<TeamInvitationsListState> = createListReducer({
  actionNames: [
    TEAM_MEMBERS_ACTION_NAMES.GET_INVITATIONS_MEMBERS_FOR_PROJECT_START,
    TEAM_MEMBERS_ACTION_NAMES.GET_INVITATIONS_MEMBERS_FOR_PROJECT_SUCCESS,
    TEAM_MEMBERS_ACTION_NAMES.GET_INVITATIONS_MEMBERS_FOR_PROJECT_ERROR,
  ],
  payloadExtractorOptions: PredefinedPayloadExtractor.CallApi,
  key: 'id',
});

export const projectInvitationsListState = (
  state: TeamInvitationsListState = teamInvitationsListDefaultState,
  action,
) => {
  const invitationsListState = membersReducer(state, action);

  switch (action.type) {
    case PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.SEND_PROJECT_INVITATION_SUCCESS: {
      const memberInvitation = normalizeInvitation(action.payload);

      return appendNewItem(invitationsListState, memberInvitation, 'id');
    }

    case PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.ADD_INVITATION_TO_PROJECT_SUCCESS:
    case PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.REMOVE_INVITATION_PERMISSIONS_SUCCESS:
      return updateItemByKey<TeamMember>(
        invitationsListState,
        (teamMember) => ({
          ...teamMember,
          securityGroups: normalizeSecurityGroups(
            action.payload.securityGroups,
          ),
        }),
        action.payload.memberId,
      );

    case TEAM_MEMBERS_LIST_ACTION_NAMES.DELETE_TEAM_INVITATION_SUCCESS:
      return removeItem(invitationsListState, action.payload);

    default:
      return invitationsListState;
  }
};
